import { gql } from "@apollo/client";

export const GET_FASE_PACIENTE = gql`
    query getFasePaciente($idEvaluacion: Int!) {
        fasePaciente(idEvaluacion: $idEvaluacion)
    }
`;